module.exports = __webpack_public_path__ + "static/fonts/Mont-Heavy.77e839f.ttf";